<app-alerts-bar></app-alerts-bar>

<div class="app-shell">
  <app-nav></app-nav>

  <div [ngStyle]="{'max-width': isFileOnline ? '1800px' : '#inherit'}" class="container page-content">
    @if (environmentService.showQaBanner()) {
      <div id="QA Alert" class="efile-disabled">
        <h3 style="color: black; text-align: center">FOR INTERNAL USE ONLY</h3>
        <h3 style="color: black; text-align: center">ANY SUBMISSION WILL NOT BE PROCESSED</h3>
        <p style="color: black; margin-bottom: 0; text-align: center"><b>This site is intended for quality assurance testing. Click to visit <a href="https://assessor.lacounty.gov">The Official Assessor Website</a></b>.</p>
        <!--    <button class="btn" style="width: 200px" (click)="onDismissBanner()">Click to dismiss</button>-->
      </div>
    }
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>

  <app-footer class="page-footer"></app-footer>
</div>


<app-newsletter-popup></app-newsletter-popup>
<button #slideInButton
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseOut()"
        (click)="chatService.openChatBot()"
        aria-haspopup="dialog"
        [attr.aria-expanded]="chatService.toggle"
        [hidden]="useNewChatbot()"
        class="expand-button slide-in-button fade-button pulse-button typing-button">
  <i class="fas fa-comment-dots" aria-hidden="true"></i><strong>{{typingText}}</strong>
</button>

<!-- ?useNewChatbot: the Assessor Assistant (it has its own launcher). Otherwise the legacy chatbot. -->
@if (useNewChatbot()) {
  <app-assessor-assistant></app-assessor-assistant>
} @else {
  <app-chatbot></app-chatbot>
}
